import { appGrep } from '../../../../../utils/appGrep.js';
import { detectAppChanges } from '../../../lib/detectAppChanges.js';

export const appActionName = {
  key: 'name',
  type: 'app',
  label: 'Action Name',
  description: 'The name of the action.',
  path: 'actions[id:{{actionId}}].name',
  shouldRun: ({ changes, actionId }) =>
    detectAppChanges(changes, {
      type: 'action',
      actionId,
      keys: ['', 'name', 'description', 'slug']
    }),
  mapContext: ({ app, action }) => {
    const baseUrl = appGrep(app).actionApi({ action })?.baseUrl;

    const otherActionNames = app?.actions
      ?.filter((n) => n?.id !== action?.id)
      ?.map((n) => n?.name)
      .join(', ');
    const context = {
      appName: app?.name,
      actionDetails: {
        name: action?.name,
        slug: action?.slug,
        httpMethod: action?.api?.method,
        httpPath: `${baseUrl || ''}${action?.api?.path}`,
        notes: action?.notes,
        description: action?.description,
        objectType: action?.model,
        objectOperation: action?.operation
      },
      otherActionNames
    };
    return context;
  },
  prompt: 'appActionName'
};
